import { Routes } from '@angular/router';
import { ARRECADACAO_ROUTES } from './arrecadacao.constants';
import { SemAcesso } from '@/core/permissions/sem-acesso/sem-acesso';
import { arrecadacaoRelatorioRoutes } from '@/features/financeiro/arrecadacao/relatorios/arrecadacao-relatorio.routes';
import { arrecadacaoServicosRoutes } from '@/features/financeiro/arrecadacao/servicos/arrecadacao-servicos.routes';
import { dashboardArrecadacaoRoutes } from './dashboard-arrecadacao/dashboard-arrecadacao.routes';

export const arrecadacaoRoutes: Routes = [
    {
        // Entrada sem guard: sempre abre e mostra o menu interno (arrecadacao-content acinzenta
        // as funcionalidades por role); dashboard é pessoa-cêntrico, sem load/toast na entrada.
        path: ARRECADACAO_ROUTES.ROOT,
        loadComponent: () => import('./arrecadacao-content').then((m) => m.ArrecadacaoContent),
        data: { breadcrumb: 'Arrecadação' },
        children: [
            { path: '', redirectTo: ARRECADACAO_ROUTES.DASHBOARD, pathMatch: 'full' },
            // Alvo do fallback do arrecadacaoDashboardLandingGuard quando nenhuma funcionalidade
            // da ordem de aterrissagem é alcançável. Filha de ROOT (não irmã, como o `/sem-acesso`
            // global) DE PROPÓSITO: sendo filha, este `ArrecadacaoContent` continua montado e o
            // menu lateral do módulo aparece junto da mensagem — sem isso, quem caísse aqui
            // ficaria numa tela sem menu, o mesmo dead-end que este guard existe para evitar.
            // SEM permissionGuard: uma rota de "sem acesso" que nega a si mesma seria um beco sem
            // saída (D3 preserva a URL, mas o componente teria que renderizar assim mesmo).
            { path: ARRECADACAO_ROUTES.SEM_ACESSO, component: SemAcesso, data: { breadcrumb: 'Sem acesso' } },
            ...dashboardArrecadacaoRoutes,
            ...arrecadacaoServicosRoutes,
            ...arrecadacaoRelatorioRoutes
        ]
    }
];
